import { regist, login, sclLogin, loginOut, loginPassword,forgetPassword, saveArea, teamInfoEdit } from '@/api/user'
import { checkActivate, checkVip } from '@/api/vip'
import { Message } from 'element-ui'
import { setToken, getToken, removeToken } from '@/utils/auth'
import router from '../../router'
import { getBatch } from '../../api/home'
const subject_obj = JSON.parse(sessionStorage.getItem('subjectObj'))
const state = {
    isLogin: false,
    isRegister: false,
    isUserLogin: false,
    isCompare: false,
    isForget: false,
    isShowGk: false,
    isShowVip: false,
    isShowAddVip: false,
    isShowPlan: false,
    isShowUserName: false,
    isSaveUserName: false,
    isProvince: false,
    isShowProvince: false,
    isWechatPay: false,
    isIntentionCity: false, 
    isIntentionSchool: false,
    isIntentionMajor: false,
    isIntentionJob: false,
    isFav: false,
    compareSchoolList: [],
    token: getToken(),
    isVipStr: localStorage.getItem("isVipStr") ? localStorage.getItem("isVipStr") : 'false',
    vipType: localStorage.getItem("vipType") ? localStorage.getItem("vipType") : 1,
    axiosCancelArr: [],
    mobile: localStorage.getItem("mobile") ? localStorage.getItem("mobile") : '',
    head_img: localStorage.getItem("head_img") ? localStorage.getItem("head_img") : '',
    provinceCode: getToken() ? localStorage.getItem("area") : '41',
    localTypeId: getToken() ? localStorage.getItem("localTypeId") : '1',
    subject_name: getToken() ? localStorage.getItem("subject_name") : '物理,化学,生物',
    gk_year: localStorage.getItem("gk_year"),
    gkInforObj: localStorage.getItem("gkInforObj") ? JSON.parse(localStorage.getItem("gkInforObj")) : '',
    // gkInforObj: '',
    savePlanInfor: {},
    requestCount: 0,
    qr_code: '',
    loginError: false,
    function_code: [],
    qr_pic: '',
    website: {},
    areaList: {}
}
const mutations = {
    LOGINSTATUS(state, isLogin) {
        state.isLogin = isLogin;
    },
    REGISTER(state, isRegister) {
        state.isRegister = isRegister;
    },
    FORGET(state, isForget) {
        state.isForget = isForget;
    },
    SClUSERLOGIN(state, isUserLogin) {
        state.isUserLogin = isUserLogin;
    },
    SHOWGKINFOR(state, isShowGk) {
        state.isShowGk = isShowGk;
    },
    SHOWVIP(state, isShowVip) {
        state.isShowVip = isShowVip;
    },
    VIPSTATUS(state, isVipStr) {
        state.isVipStr = isVipStr;
        localStorage.setItem("isVipStr", state.isVipStr);
    },
    VIPTYPESTATUS(state, vipType) {
        state.vipType = vipType;
        localStorage.setItem("vipType", vipType);
    },
    COMPARESTATUS(state, isCompare) {
        state.isCompare = isCompare;
    },
    SHOWADDVIP(state, isShowAddVip) {
        state.isShowAddVip = isShowAddVip;
    },
    SHOWSAVEPLAN(state, isShowPlan) {
        state.isShowPlan = isShowPlan;
    },
    SHOWSAVEUSERNAME(state, isShowUserName) {
        state.isShowUserName = isShowUserName;
    },
    SAVEUSERNAMESUC(state, isSaveUserName) {
        state.isSaveUserName = isSaveUserName;
    },
    SHOWPROVINCE(state, isProvince) {
        state.isProvince = isProvince;
    },
    SHOWWECHAT(state, isWechatPay) {
        state.isWechatPay = isWechatPay;
    },
    SHOWINTENTIONCITY(state, isIntentionCity) {
        state.isIntentionCity = isIntentionCity;
    },
    SHOWINTENTIONSCHOOL(state, isIntentionSchool) {
        state.isIntentionSchool = isIntentionSchool;
    },
    SHOWINTENTIONMAJOR(state, isIntentionMajor) {
        state.isIntentionMajor = isIntentionMajor;
    },
    SHOWINTENTIONJOB(state, isIntentionJob) {
        state.isIntentionJob = isIntentionJob;
    },
    SHOWISFAV(state, isFav) {
        state.isFav = isFav;
    },
    EDITGKINFOR(state, gkInforObj) {
        state.gkInforObj = gkInforObj;
        localStorage.setItem("gkInforObj", JSON.stringify(gkInforObj));
    },
    EDITSAVEPLANINFOR(state, savePlanInfor) {
        state.savePlanInfor = savePlanInfor;
    },
    COMPARESCHOOLLIST(state, compareSchoolList) {
        state.compareSchoolList = compareSchoolList;
    },
    SAVETOKEN(state, token) {
        state.token = token;
    },
    CHANGEPROVINCE(state,provinceCode) {
        state.provinceCode = provinceCode;
        localStorage.setItem('area', provinceCode)
    },
    CHANGELOCALTYPEID(state,localTypeId) {
        state.localTypeId = localTypeId;
        localStorage.setItem('localTypeId', localTypeId)
    },
    CHANGESUBJECT(state,subject_name) {
        state.subject_name = subject_name;
        localStorage.setItem('subject_name', subject_name)
    },
    CHANGEYEAR(state,gk_year) {
        state.gk_year = gk_year;
        localStorage.setItem('gk_year', gk_year)
    },
    CHANGEWEB(state,website) {
        state.website = website;
    },
    CHANGEAREA(state,areaList) {
        state.areaList = areaList;
    },
    CHANGPRO(state,isShowProvince) {
        state.isShowProvince = isShowProvince;
    },
    FUNCTIONCODE(state,function_code) {
        state.function_code = function_code;
    },
    GETBATCH() {
        return new Promise((resolve) => {
            const params = {
                area: localStorage.getItem("area")
            }
            getBatch(params).then(response => {
                sessionStorage.setItem('newSubject', JSON.stringify(response.data.local_type_id))
                sessionStorage.setItem('newBatch', JSON.stringify(response.data.local_batch_id))
                resolve(response)
            }).catch(error => {
                console.log(error);
            })
        })
    },
    LOGIN(state, { phone, code, smsToken }) {
        return new Promise((resolve) => {
            login(phone, code, smsToken).then(response => {
                if(response.status == '400') {
                    Message({
                        message: response.message,
                        type: 'error',
                        duration: 5 * 1000
                    })
                    // state.loginError = true;
                    return 
                }
                // state.loginError = false;
                state.token = response.data.token;
                setToken(response.data.token);
                state.isLogin = false;
                localStorage.setItem("hasLogin",'false');
                this.commit('user/GETINFOR');
                if(!response.data.area) {
                    if(!localStorage.getItem('localTypeId')) {
                        state.isProvince = true
                    } else {
                        this.commit('user/SAVEAREA');
                    }
                } else {
                    if(!response.data.local_type_id) {
                        state.isProvince = true
                    } else {
                        if(!response.data.year) {
                            let year = new Date().getFullYear()
                            if(new Date().getMonth() > 7) {
                                year = (new Date().getFullYear()) + 1
                              }
                            state.gk_year = year
                            localStorage.setItem("gk_year",year);
                            this.commit('user/SAVEAREA');
                        } else {
                            state.gk_year = response.data.year;
                            localStorage.setItem("gk_year",state.gk_year);
                        }
                        localStorage.setItem("area", response.data.area);
                        state.provinceCode = response.data.area;
                        state.localTypeId = response.data.local_type_id
                        localStorage.setItem("localTypeId",response.data.local_type_id);
                        state.subject_name = response.data.subject_name ? response.data.subject_name : subject_obj[response.data.local_type_id].name
                        localStorage.setItem("subject_name",state.subject_name);
                        
                    }
                }
                resolve(response)
            }).catch(error => {
                console.log(error);
            })
        })
    },
    LOGINPASSWORD(state, { user_name, password, geetest_challenge, geetest_validate, geetest_seccode }) {
        state.loginError = false;
        return new Promise((resolve, reject) => {
            loginPassword(user_name, password, geetest_challenge, geetest_validate, geetest_seccode).then(response => {
                if(response.status == '400') {
                    Message({
                        message: response.message,
                        type: 'error',
                        duration: 5 * 1000
                    })
                    state.loginError = true;
                    reject(response)
                    return 
                }
                state.isLogin = false;
                state.loginError = false;
                state.token = response.data.token;
                setToken(response.data.token);
                localStorage.setItem("hasLogin",'false');
                this.commit('user/GETINFOR');
                if(!response.data.area) {
                    if(!localStorage.getItem('localTypeId')) {
                        state.isProvince = true
                    } else {
                        this.commit('user/SAVEAREA');
                    }
                } else {
                    if(!response.data.local_type_id) {
                         state.isProvince = true
                    } else {
                        if(!response.data.year) {
                            let year = new Date().getFullYear()
                            if(new Date().getMonth() > 7) {
                                year = (new Date().getFullYear()) + 1
                            }
                            state.gk_year = year
                            localStorage.setItem("gk_year",year);
                            this.commit('user/SAVEAREA');
                        } else {
                            state.gk_year = response.data.year;
                            localStorage.setItem("gk_year",state.gk_year);
                        }
                        localStorage.setItem("area", response.data.area);
                        state.provinceCode = response.data.area;
                        state.localTypeId = response.data.local_type_id
                        localStorage.setItem("localTypeId",response.data.local_type_id);
                        state.subject_name = response.data.subject_name ? response.data.subject_name : subject_obj[response.data.local_type_id].name
                        localStorage.setItem("subject_name",state.subject_name);
                    }
                }
                resolve(response)
            }).catch(error => {
                console.log(error);
            })
        })
    },
    SCLLOGIN(state, { stu_no, password }) {
        state.loginError = false;
        return new Promise((resolve, reject) => {
            sclLogin(stu_no, password).then(response => {
                if(response.status == '400') {
                    Message({
                        message: response.message,
                        type: 'error',
                        duration: 5 * 1000
                    })
                    state.loginError = true;
                    reject(response)
                    return 
                }
                state.isLogin = false;
                state.loginError = false;
                state.token = response.data.token;
                setToken(response.data.token);
                localStorage.setItem("hasLogin",'false');
                this.commit('user/GETINFOR');
                if(!response.data.area) {
                    if(!localStorage.getItem('localTypeId')) {
                        state.isProvince = true
                    } else {
                        this.commit('user/SAVEAREA');
                    }
                } else {
                    if(!response.data.local_type_id) {
                         state.isProvince = true
                    } else {
                        if(!response.data.year) {
                            let year = new Date().getFullYear()
                            if(new Date().getMonth() > 7) {
                                year = (new Date().getFullYear()) + 1
                            }
                            state.gk_year = year
                            localStorage.setItem("gk_year",year);
                            this.commit('user/SAVEAREA');
                        } else {
                            state.gk_year = response.data.year;
                            localStorage.setItem("gk_year",state.gk_year);
                        }
                        localStorage.setItem("area", response.data.area);
                        state.provinceCode = response.data.area;
                        state.localTypeId = response.data.local_type_id
                        localStorage.setItem("localTypeId",response.data.local_type_id);
                        state.subject_name = response.data.subject_name ? response.data.subject_name : subject_obj[response.data.local_type_id].name
                        localStorage.setItem("subject_name",state.subject_name);
                    }
                }
                resolve(response)
            }).catch(error => {
                console.log(error);
            })
        })
    },
    RESETTOKEN(state) {
        return new Promise(resolve => {
            removeToken()
            resolve()
        })
    },
    PUSH_CANCEL(state, cancel) {
        state.axiosCancelArr.push(cancel.cancelToken);
    },
    CLEAR_CANCEL(state) {
        state.axiosCancelArr.forEach(e => {
            e && e()
        });
        state.axiosCancelArr = []
    },
    LOGINOUT(state) {
        return new Promise((resolve, reject) => {
            loginOut().then(res => {
                removeToken();
                localStorage.removeItem("mobile");
                localStorage.removeItem("gkInforObj");
                localStorage.removeItem("ZHIYUANSTATUS");
                localStorage.removeItem("head_img");
                localStorage.removeItem("isVipStr");
                localStorage.removeItem("vipType");
                localStorage.removeItem("isNewUser");
                localStorage.removeItem("token");
                localStorage.removeItem("function_code");
                // localStorage.removeItem("area");
                // localStorage.removeItem("provinceCode");
                state.token = '';
                state.mobile = '';
                state.gkInforObj = '';
                state.head_img = '';
                state.isVipStr = 'false';
                state.vipType = 1;
                state.requestCount = 0;
                state.compareSchoolList = [];
                // state.provinceCode = '13';
                // state.localTypeId = '3';
                state.function_code = [];
                router.push('/home')
                resolve(res)
            }).catch(error => {
                reject(error)
            })
        })
    },
    REGISTERUSER(state, { user_name, mobile, sms_code, sms_token, password }) {
        return new Promise((resolve) => {
            regist(user_name, mobile, sms_code, sms_token, password).then(response => {
                if(response.status != '200') {
                    Message({
                        message: response.message,
                        type: 'error',
                        duration: 5 * 1000
                    })
                    return
                }
                state.isRegister = false;
                state.token = response.data.token;
                setToken(response.data.token);
                localStorage.setItem("hasLogin",'false');
                // localStorage.setItem("functionCodeList",JSON.stringify(response.data.function_code));
                if (response.data.is_vip == '0') {
                    state.isVipStr = 'false';
                    state.isShowAddVip = true;
                    localStorage.setItem("isNewUser","true");
                } else {
                    state.isVipStr = 'true';
                    state.isShowAddVip = false;
                    localStorage.setItem("isNewUser","false");
                }
                this.commit('user/GETINFOR');
                if(!response.data.area) {
                    if(!localStorage.getItem('localTypeId')) {
                        state.isProvince = true
                    } else {
                        this.commit('user/SAVEAREA');
                    }
                } else {
                    if(!response.data.local_type_id) {
                         state.isProvince = true
                    } else {
                        if(!response.data.year) {
                            let year = new Date().getFullYear()
                            if(new Date().getMonth() > 7) {
                                year = (new Date().getFullYear()) + 1
                            }
                            state.gk_year = year
                            localStorage.setItem("gk_year",year);
                            this.commit('user/SAVEAREA');
                        } else {
                            state.gk_year = response.data.year;
                            localStorage.setItem("gk_year",state.gk_year);
                        }
                        localStorage.setItem("area", response.data.area);
                        state.provinceCode = response.data.area;
                        state.localTypeId = response.data.local_type_id
                        localStorage.setItem("localTypeId",response.data.local_type_id);
                        state.subject_name = response.data.subject_name ? response.data.subject_name : subject_obj[response.data.local_type_id].name
                        localStorage.setItem("subject_name",state.subject_name);
                    }
                }
                resolve(response)
            }).catch(error => {
                console.log(error);
            })
        })
    },
    FORGETPASSWORD(state, { mobile, sms_code, sms_token, new_password }) {
        return new Promise((resolve) => {
            forgetPassword(mobile, sms_code, sms_token, new_password).then(response => {
                Message({
                    message: '修改成功',
                    type: 'success',
                    duration: 5 * 1000
                })
                state.isForget = false;
                resolve(response)
            }).catch(error => {
                console.log(error);
            })
        })
    },
    SAVEHEADIMG(state, head_img) {
        state.head_img = head_img;
    },
    ADDCOUNT(state, requestCount) {
        state.requestCount = requestCount;
        localStorage.setItem("requestCount", requestCount);
    },
    QRCODE(state,qr_code) {
        state.qr_code = qr_code
    },
    GETINFOR(state) {
        return new Promise((resolve, reject) => {
            checkActivate(state.token).then(response => {
                if(response.status == '400') {
                    Message({
                        message: response.message,
                        type: 'error',
                        duration: 5 * 1000
                    })
                    state.loginError = true;
                    return 
                } else if(response.status == '401') {
                    state.token = '';
                    setToken('');
                    state.loginError = true;
                    return 
                }
                state.mobile = response.data.mobile;
                state.qr_pic = 'https://gaokao.zmpajx.com' + response.data.qr_pic
                localStorage.setItem("mobile", response.data.mobile);
                let head_img = response.data.head_img;
                if (head_img) {
                    let uploadUrl = 'https://gaokao.zmpajx.com/';
                    // let uploadUrl = process.env.VUE_APP_BASE_API;
                    state.head_img = uploadUrl + response.data.head_img;
                    localStorage.setItem("head_img", uploadUrl + response.data.head_img);
                }
                checkVip().then(res => {
                    state.vipType = res.data.has_code;
                    const function_code = res.data.function_code;
                    state.function_code = function_code
                    if (res.data.has_code != '0') {
                        state.isVipStr = 'false';
                    } else {
                        state.isVipStr = 'true';
                    }
                    localStorage.setItem("isVipStr", state.isVipStr);
                    localStorage.setItem("vipType", state.vipType);
                })
                resolve(response)
            }).catch(error => {
                console.log(error);
            })
        })
    },
    SAVEAREA(state) {
        return new Promise((resolve, reject) => {
            teamInfoEdit('', state.localTypeId, '', state.gk_year, state.subject_name).then(res => {
                    resolve(response)
            }).catch(error => {
                console.log(error);
            })
        })
    }
};

const actions = {
    LOGIN({ commit }, { phone, code, smsToken }) {
        commit('LOGIN', { phone, code, smsToken });
    },
    GETINFOR({ commit }) {
        commit('GETINFOR');
    },
    LOGINPASSWORD({ commit }, { user_name, password, geetest_challenge, geetest_validate, geetest_seccode }) {
        commit('LOGINPASSWORD', { user_name, password, geetest_challenge, geetest_validate, geetest_seccode });
    },
    SCLLOGIN({ commit }, { stu_no, password }) {
        commit('SCLLOGIN', { stu_no, password });
    },
    FORGETPASSWORD({ commit }, { mobile, sms_code, sms_token, new_password }) {
        commit('FORGETPASSWORD', { mobile, sms_code, sms_token, new_password });
    },
    REGISTERUSER({ commit }, { user_name, mobile, sms_code, sms_token, password }) {
        commit('REGISTERUSER', { user_name, mobile, sms_code, sms_token, password });
    },
    RESETTOKEN({ commit }) {
        commit('RESETTOKEN');
    },
    PUSH_CANCEL({ commit }, cancel) {
        commit('PUSH_CANCEL', cancel)
    },
    CLEAR_CANCEL({ commit }) {
        commit('CLEAR_CANCEL');
    },
    LOGINOUT({ commit }) {
        commit('LOGINOUT');
    },
};
const getters = {

};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}